import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { BORDER, SURFACE_HEADER, TEXT_MUTED, TEXT_PRIMARY } from './tokens';

/**
 * Page header for a Voice sub-screen.
 *
 * Five screens carried a near-identical copy of this, and a sixth
 * (CallHistory) had drifted badly — a `text-sm` h1 with `py-2` next to
 * `text-2xl` / `py-6` on every sibling screen, so navigating between them
 * felt like changing apps.
 *
 * Sticky so the title and primary actions stay reachable while scrolling a
 * long table, which none of the originals did.
 */
const PageHeader = ({ title, subtitle, backTo = '/voice', actions, badge }) => {
  const navigate = useNavigate();

  return (
    <div className={`sticky top-0 z-20 border-b ${BORDER} ${SURFACE_HEADER} backdrop-blur`}>
      <div className="px-6 py-4 flex items-center gap-4">
        {backTo && (
          <button
            onClick={() => navigate(backTo)}
            aria-label="Back"
            className="p-2 -ml-2 rounded-lg text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-white/[0.06] transition-colors"
          >
            <ArrowLeftIcon className="w-5 h-5" />
          </button>
        )}

        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2.5">
            <h1 className={`text-xl font-semibold truncate ${TEXT_PRIMARY}`}>{title}</h1>
            {badge}
          </div>
          {subtitle && <p className={`text-[13px] mt-0.5 truncate ${TEXT_MUTED}`}>{subtitle}</p>}
        </div>

        {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
      </div>
    </div>
  );
};

export default PageHeader;
